import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';
import {AuthService} from '../auth/auth.service';
import {HelperProvider} from './helper.provider';


@Injectable({
  providedIn: 'root',
})
export class TimingInterceptor implements HttpInterceptor {
  TAG = 'TimingInterceptor';
  noShowLoadingEndpoints: string[] = [
    'TalepTalepKalem/KalemAra'
  ];


  constructor(private router: Router,
              private authService: AuthService,
              private helperProvider: HelperProvider) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();
    const token = this.authService.getToken();
    const branchesArray = this.authService.getSelectedSubeIdList();
    let branches = '';
    if (branchesArray != null) {
      branches = branchesArray.join(',');
    }
    if (req.url.indexOf('UploadFile') !== -1 || req.url.indexOf('ExcelYukle') !== -1) {
      debugger;
      if (token) {
        req = req.clone({
          setHeaders:
            {
              Authorization: 'Bearer ' + token,
              Branches: branches
            }
        });
      }
    } else if (token) {
      req = req.clone({
        setHeaders:
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            Branches: branches
          }
      });
    } else {
      req = req.clone({
        setHeaders:
          {
            'Content-Type': 'application/json',
            Branches: branches
          }
      });
    }

    // console.log(req);
    // console.log('url: ' + req.url);
    if (req.url.indexOf(environment.endpoint) !== -1 && this.noShowLoadingEndpoints.indexOf(req.url) === -1) {
      this.helperProvider.loading$.next(true);
    }

    return next
      .handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            if (req.url.indexOf(environment.endpoint) !== -1) {
              this.helperProvider.loading$.next(false);
            }
            if (!environment.production) {
              const elapsed = Date.now() - started;
              console.warn({
                  url: req.urlWithParams.replace(environment.endpoint, ''),
                  elapsed: `${elapsed} ms`,
                  body: req.body,
                  response: event.body
                },
              );
            }
          }
        }), catchError((err: any) => {
          if (req.url.indexOf(environment.endpoint) !== -1) {
            this.helperProvider.loading$.next(false);
          }
          console.log('Unknown http error, please report. ' + req.url);
          console.log(err);
          let message = 'Unknown Error Text';
          if (err.error != null && err.error.message != null) {
            message = err.error.message;
          }
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 0:
                alert('Connecting Error Text');
                break;
              case 400:
                alert(message);
                break;
              case 401:
                alert('Unauthorized Error Text');
                //this.authService.logout();
                break;
              case 403:
                alert('Forbidden Error Text');
                // this.authService.logout();
                break;
              case 500:
                alert(message);
                break;
            }
          }
          return throwError(err);
        }));
  }

}
